import Vue from 'vue';
import { toCurrency, toUpperCase, toDateTime, timeAgo } from './formatters';

Vue.filter('toCurrency', toCurrency);
Vue.filter('toUpperCase', toUpperCase);
Vue.filter('toDateTime', toDateTime);
Vue.filter('timeAgo', timeAgo);
